import React, { useContext, useState, useEffect } from "react";
import { doVerifyOtp, doResendOtp } from "@AUTH";
import { Form, Input, Button, Space, Statistic } from "antd";
import { AuthContext } from "@CONTEXTS";
import { useHistory } from "react-router";
import { Constants } from "@CONFIG";
const { Countdown } = Statistic;
const OtpPage = ({ verification }) => {
  const history = useHistory();
  const { setToken } = useContext(AuthContext);
  const [timerFinished, setTimerFinished] = useState(false);
  const [resendTimerFinished, setResendTimerFinished] = useState(false);

  const [expiresAtString, setExpireAtString] = useState(
    verification?.expiresAt.toLocaleString()
  );
  const [reverificationId, setReverificationId] = useState(null);

  const [loading, setLoading] = useState(false);
  const onFinish = async (val) => {
    setLoading(true);
    const token = await doVerifyOtp({
      verificationId: reverificationId
        ? reverificationId
        : verification.verificationId,
      verificationCode: val.verificationCode,
    });
    if (token === "BLOCKEDOTP") {
      setTimeout(() => {
        history.go(0);
      }, 2000);
    } else if (token) {
      setToken(token);
      if (localStorage.getItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY)) {
        localStorage.removeItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY);
      }
      history.go(0);
    }
    setLoading(false);
  };
  const onTimerFinish = () => {
    setTimerFinished(true);
  };
  const startResendTimer = () => {
    setResendTimerFinished(false);

    const timer = setTimeout(() => {
      setResendTimerFinished(true);
    }, 60 * 1000);

    return timer;
  };

  useEffect(() => {
    const timer = startResendTimer();

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // 5 dakika sonra ana sayfaya yönlendir ve tokenı sil
    const redirectTimer = setTimeout(() => {
      if (localStorage.getItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY)) {
        localStorage.removeItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY);
      }
      history.push("/"); // Anasayfa
    }, 5 * 60 * 1000);

    return () => clearTimeout(redirectTimer);
  }, [history]);

  const resendOtp = async () => {
    try {
      setLoading(true);
      const payload = { verificationId: verification.verificationId };
      const response = await doResendOtp(payload);
      if (response) {
        setReverificationId(response.verificationId);
        setExpireAtString(response.expiresAt.toLocaleString());
        setTimerFinished(false);
        startResendTimer();
        setResendTimerFinished(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        marginTop: "5%",
        width: "70%",
        justifyContent: "space-between",
      }}
    >
      <h2>Hoş geldiniz</h2>
      <h4>{verification.message}</h4>
      <Countdown
        value={expiresAtString}
        format="mm:ss"
        onFinish={() => onTimerFinish()}
      />
      <Form
        layout="vertical"
        name="basic"
        onFinish={(val) => onFinish(val)}
        style={{ width: "100%" }}
      >
        <Form.Item
          name="verificationCode"
          rules={[
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.reject("Lütfen doğrulama kodunu giriniz.");
                }

                // OTP'nin 6 haneli olması gerektiğini kontrol et
                if (value.length !== 6) {
                  return Promise.reject("Doğrulama kodu 6 haneli olmalıdır.");
                }

                // OTP'nin sadece rakamlardan oluşması gerektiğini kontrol et
                if (!/^\d{6}$/.test(value)) {
                  return Promise.reject(
                    "Doğrulama kodu yalnızca rakamlardan oluşmalıdır."
                  );
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <Input maxLength={6} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            style={{ background: "#F47729", borderRadius: "10px" }}
            disabled={timerFinished}
          >
            Kodu Doğrula
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            size="large"
            type="primary"
            onClick={resendOtp}
            block
            loading={loading}
            className="reSend-btn"
            style={{
              background: "#39166C",
              borderRadius: "10px",
              color: "gray !important",
            }}
            disabled={!timerFinished && !resendTimerFinished}
          >
            Kodu Yeniden Gönder
          </Button>
        </Form.Item>
      </Form>
    </Space>
  );
};

export default OtpPage;
